import { render, staticRenderFns } from "./ElementMultiInstance.vue?vue&type=template&id=788c53b6"
import script from "./ElementMultiInstance.vue?vue&type=script&lang=js"
export * from "./ElementMultiInstance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports